import other from "../img/other.webp";
import kom from "../img/kom.webp"

import workThree from "../img/sill.webp";
import workFour from "../img/reception.webp";

import workSix from "../img/ourstairs.webp";

import barTwo from "../img/barn.webp"
import barThree from "../img/bar/bar1.webp"


import workOne from "../img/bathroom/w_03.webp";
import bathFour from "../img/bathroom/w_01.webp"
import bathFive from "../img/bathroom/w_02.webp"


import kitchen1 from "../img/mykichen.webp"
import kitchen2 from "../img/kitchen/w_02.webp"
import kitchen4 from "../img/kitchen/w_01.webp"
import kitchen5 from "../img/kitchen/k8.webp"
import kitchen6 from "../img/kitchen/w_4.webp"



import sillOne from "../img/11.webp"
import sillTwo from "../img/222.webp"
import sillThree from "../img/333.webp"


export const works = [
    {
      images: [workOne, bathFour, bathFive],
      title: "Столешницы из камня для ванной комнаты",
      id: 1,
      subtitle: "Столешницы из кварцевого агломерата для ванных комнат стоит выбирать из-за их непористой структуры, которая предотвращает впитывание влаги и защищает от плесени и бактерий, обеспечивая гигиеничность. Они также устойчивы к косметическим средствам, царапинам и просты в уходе, сохраняя элегантный вид на долгие годы.",
      description: ["Изготовлена из квацевого камня Belenco 'Perla White'", "Изготовлена из квацевого камня Radianz 'Everest White'", "Изготовлена из квацевого камня Stratos 'C7109 Cloud Concrete'"]
    },
    {
      images: [kitchen5, kitchen2, kitchen4, kitchen1, kitchen6],
      title: "Столешницы из камня для кухни",
      id: 2,
      subtitle: "Столешницы из кварцевого агломерата стоит выбирать из-за их высокой устойчивости к влаге, царапинам и химическим веществам, что делает их идеальными для кухонь и ванных комнат. Они долговечны, гигиеничны, не требуют сложного ухода и сохраняют эстетичный вид на десятилетия.",
      description: ["Изготовлена из квацевого камня Belenco Pixie Wings", "Изготовлена из квацевого камня Belenco 'Pixie Wings'", "Изготовлена из квацевого камня Radianz Everest White", "Изготовлена из квацевого камня Avant 'Статуарио'", "Изготовлена из квацевого камня Coante quartz majestic brown"]
    },
  
    {
      images: [workSix],
      title: "Лестницы из камня",
      id: 3,
      subtitle: "Лестницы из кварцевого агломерата стоит выбирать благодаря их исключительной прочности и устойчивости к износу, что обеспечивает долговечность даже при интенсивной эксплуатации. Они также обладают эстетичным видом, не требуют сложного ухода и устойчивы к пятнам, влаге и механическим повреждениям.",
      description: ["Изготовлена из квацевого камня Caesarstone 'Pure White'"]
    },
  
    {
      images: [workFour],
      title: "Ресепшен из камня для вашего бизнеса",
      id: 4,
      subtitle: "Ресепшены из кварцевого агломерата стоит выбирать из-за их элегантного внешнего вида и высокой устойчивости к царапинам, пятнам и химическим воздействиям, что идеально для зон с высокой проходимостью. Они просты в уходе, долговечны и подчеркивают профессиональный имидж бизнеса.",
      description: ["Изготовлена из квацевого камня Noblle 'Calacatta Venato'"]
    },
    {
      images: [other, kom],
      title: "Прочее",
      id: 5,
      subtitle: "Изделия из кварцевого агломерата, такие как навесные полочки, подставки для растений или декоративные панели, стоит выбирать за их долговечность, устойчивость к влаге и легкость в уходе, что делает их идеальными для любых интерьеров. Они также предлагают эстетическую универсальность, позволяя создавать стильные и функциональные элементы, например, настенные консоли или рамки для зеркал, которые сохраняют безупречный вид годами.",
      description: ["Полка изготовлена из квацевого камня Avant 'Аваллон'", "Столешница на комод из кварцевого камня Avant 'Иль Де Франс'"]

    },
    {
      images: [sillTwo, workThree, sillOne, sillThree],
      title: "Подоконник из камня",
      id: 6,
      subtitle: "Подоконники из кварцевого агломерата стоит выбирать из-за их высокой прочности, устойчивости к влаге и перепадам температур, что идеально для помещений с повышенной влажностью или частым воздействием солнца. Они не требуют сложного ухода, устойчивы к пятнам и царапинам, сохраняя эстетичный вид на долгие годы.",
      description: ["Подоконник из квацевого камня Avant Calacatta", "Подоконник из квацевого камня Caesarstone Frosty Carrina", "Подоконник из квацевого камня Belenco Fairy White", "Подоконник из квацевого камня Belenco White"]

    },
    {
      images: [barTwo, barThree],
      title: "Барная стойка",
      id: 7,
      subtitle: "Барные стойки из кварцевого агломерата стоит выбирать из-за их высокой устойчивости к пятнам, царапинам и воздействию жидкостей, что делает их идеальными для интенсивного использования в барах и ресторанах. Они также отличаются долговечностью, легкостью в уходе и привлекательным дизайном, который подчеркивает стиль интерьера.",
      description: ["Изготовлена из квацевого камня Belenco 'Calacatta Venezia", "Изготовлена из квацевого камня Noblle 'Calacatta Venato'"]
    },
  ];